import {AfterViewInit, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {UsuarioService} from 'src/app/services/usuario.service';
import {Usuario} from 'src/app/model/usuario.model';
import {Mask} from 'src/app/model/mask.model';
import {DatePipe} from '@angular/common';
import * as moment from 'moment';
import {GenericValidator} from 'src/app/generic-validator';
import {RecaptchaComponent} from 'ng-recaptcha';
import {first} from 'rxjs/operators';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomSiteService} from '../../services/customsite.service';

@Component({
    selector: 'app-cadastro',
    templateUrl: './cadastro.component.html',
    styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent implements OnInit, AfterViewInit {
    @ViewChild('rc', { static: true }) rc: RecaptchaComponent;
    captchaToken: string = '';
    cpfmask = Mask.cpf;
    telefonemask = Mask.telefone;
    datamask = Mask.data;
    model: any = {};
    showSpinner = false;
    reCaptchaKey: string;
    canSignUp: boolean = true;
    agenciaSelecionada: Number;
    closeResult: string;
    termsAcceptance: string = "";
    register: string = "Este cadastro é exclusivo para o acesso ao Sistema de Atendimento da Pagmob. Para prosseguir, informe seus dados.";
    edit = false;

    constructor(
        private router: Router,
        private zone: NgZone,
        private usuarioService: UsuarioService,
        private datePipe: DatePipe,
        private _notificationService: NotificationsService,
        public datepipe: DatePipe,
        public googleAnalyticsService: GoogleAnalyticsService,
        private configService: ConfigurationService,
        private modalService: NgbModal,
        private customSiteService: CustomSiteService
        ) {
            this.onConfigLoad = this.onConfigLoad.bind( this );
            configService.loadConfigurations().subscribe( this.onConfigLoad );
        }

        ngOnInit() {
            this.googleAnalyticsService.eventEmitter("cadastro", "load", "page-load", 1);

            this.model = new Usuario();
            this.model.empresa = false;
            this.model.termsAcceptance = false;
            if (this.model.birthDate) {
                this.model.birthDate2 = this.datepipe.transform(moment(this.model.birthDate).toDate(), 'dd/MM/yyyy');
            }

            RecaptchaComponent.prototype.ngOnDestroy = function() {
                if (this.subscription) {
                    this.subscription.unsubscribe();
                }
            }

            this.getConfigSite();

            const us = localStorage.getItem('usuario')

          if(!!us && !!localStorage.getItem('cookie')) {
            const js = JSON.parse(us);
            this.model = js;
            this.model.birthDate = js.birthDate;
            this.model.birthDate2 = this.model.birthDate2 = this.datepipe.transform(moment(this.model.birthDate).toDate(), 'dd/MM/yyyy');;
            this.edit = true;
          } else this.edit = false;
        }

        ngAfterViewInit() {
            if ( this.canSignUp === false ) {
                this._notificationService.error('Cadastro', 'Não estamos aceitando novos cadastros no momento.');
                this.router.navigate(['app/login']);
            }
        }

        efetuarCadastro() {

            if (this.model.senha !== this.model.csenha) {
                this._notificationService.error('Senha', 'O campo Senha está diferente do Confirma Senha.');
                this.rc.reset();
                return;
            }

            if (this.termsAcceptance != "" && !this.model.termsAcceptance) {
                this._notificationService.error('Login', "Para realizar o cadastro no site é obrigatório aceitar os Termos de Aceite.");
                this.rc.reset();
                return;
            }

            this.model.cpf =  this.model.cpf.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
            this.model.cpf =  this.model.cpf.replace('-', '');

            if (!GenericValidator.isValidCpf(this.model.cpf)) {
                this._notificationService.error('CPF', 'CPF inválido.');
                this.rc.reset();
                return;
            }

            this.model.rg =  this.model.rg.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
            this.model.rg =  this.model.rg.replace('-', '');

            this.model.tenant = this.agenciaSelecionada;

            this.googleAnalyticsService.eventEmitter("cadastro", "button-click", "novo-cadastro", 2);

            this.showSpinner = true;
            const api = this.edit ? this.usuarioService.editCadastro(this.model) : this.usuarioService.postCadastro(this.model);
            api.pipe(first()).subscribe((result: Usuario) => {
                this._notificationService.success('Cadastro', 'Cadastro efetuado com sucesso.');
                const toast = this._notificationService.success('Cadastro', 'Direcionando para o login, aguarde...');
                this.googleAnalyticsService.eventEmitter("cadastro", "button-click", "sucesso", 3);
                if(result.userId) toast.timeoutEnd.pipe(first()).subscribe(() => {
                    this.zone.run(() => {
                        this.router.navigate(['app/dashboard']);
                    });
                    //let authModel = { login: this.model.email, senha: this.model.senha, agencyId: this.model.tenant };
                    // this.usuarioService.auth(authModel).subscribe(authResult => {
                    //     this.usuarioService.efetuarLogin(authModel, authResult).pipe(first()).subscribe(resUsuario => {
                    //         this.usuarioService.getToken(this.model.tenant).pipe(first()).subscribe((resCookie: Cookie) => {
                    //             if( !resCookie ) {
                    //                 this.showSpinner = false;//prevent from loading forever
                    //                 throw "Something wrong is not right with cookies!";
                    //             }
                    //             localStorage.setItem('cookie', JSON.stringify(resCookie.cookie));
                    //             localStorage.setItem('usuario', JSON.stringify(result));
                    //             this.zone.run(() => {
                    //                 this.router.navigate(['app/dashboard']);
                    //             });
                    //         });
                    //     }, (err) => { this.showSpinner = false; this.googleAnalyticsService.eventEmitter("login", "button-click", "erro", 4); this.rc.reset(); });
                    // }, (err) => { this.showSpinner = false; });
                }); else {
                    this._notificationService.success('Email enviado', 'Acesse seu email para confirmar o cadastro');
                    this.router.navigate(['app/dashboard']);
                }
            }, (err) => {
                this.rc.reset();
                this.showSpinner = false;
                this.googleAnalyticsService.eventEmitter("cadastro", "button-click", "erro", 4);
            });
        }

        alterarData(event: any) {
          this.model.birthDate = this.convertDateToTimeStamp(event);
        }

        convertDateToTimeStamp(date) {
          const data = moment(date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
          return moment(data).unix() * 1000;
        }

        convertTimeStampToDate(date) {
          return moment(date).format('DD/MM/YYYY HH:mm:ss');
        }

        resolved(captchaResponse: string) {
            this.model.token = captchaResponse;
            this.captchaToken = captchaResponse;
        }

        onConfigLoad( config ) {
            this.reCaptchaKey = config.reCaptchaKey;
            this.agenciaSelecionada = config.agencyId;
            if ( config.features ) {
                this.canSignUp = config.features.signUp;
            }
        }

        getConfigSite() {
          const termsAcceptance = sessionStorage.getItem("termsAcceptance");
          const register = sessionStorage.getItem("register");
          if(termsAcceptance == null && register == null)
            this.customSiteService.login(this.agenciaSelecionada).subscribe(customsite => {
                if (customsite.termsAcceptance === "<p>  </p>") this.termsAcceptance = '';
                else this.termsAcceptance = customsite.termsAcceptance;
                this.register = customsite.register;
                if(this.termsAcceptance) sessionStorage.setItem("termsAcceptance",this.termsAcceptance);
                if(this.register) sessionStorage.setItem("register",this.register);
            });
          else {
            this.termsAcceptance = termsAcceptance;
            this.register = register;
          }
        }

        openModal(content) {
            this.modalService.open(content, {size: 'lg', backdrop: 'static', ariaLabelledBy: 'modalInfoLabel'}).result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
            }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
        }

        private getDismissReason(reason: any): string {
            if (reason === ModalDismissReasons.ESC) {
                return 'by pressing ESC';
            } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
                return 'by clicking on a backdrop';
            } else {
                return  `with: ${reason}`;
            }
        }

  testNumber(senha: string, csenha: string) {
    const regx = /\d/;
    return regx.test(senha) && regx.test(csenha);
  }
  testLetter(senha: string, csenha: string) {
    const regx = /[a-zA-Z]/;
    return regx.test(senha) && regx.test(csenha);
  }
  testSpecial(senha: string, csenha: string) {
      const regx = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return regx.test(senha) && regx.test(csenha);
  }
}

    //[ngClass]="{ 'invalid': (email.invalid && email.touched) || (email.invalid && f.submitted) }"
